/**
 * Task U: Branches add-on, branch overview / stock / transfers / sharing, cashier-only checkout (rule D), staff portal.
 * One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  ["tu.nav", "Branch management", "分店管理"],
  ["tu.sub", "Every branch side by side: performance, cash flow, staff, stock, transfers — and what branches share.", "并排管理所有分店：业绩、现金流、员工、库存、调拨，以及分店之间共享什么。"],
  ["tu.tab.overview", "Performance", "业绩总览"],
  ["tu.tab.cash", "Cash flow", "现金流"],
  ["tu.tab.staff", "Staff", "员工数据"],
  ["tu.tab.stock", "Stock", "库存"],
  ["tu.tab.transfers", "Transfers", "调拨"],
  ["tu.tab.sharing", "Sharing", "共享设置"],
  ["tu.tab.sync", "Sync catalogue", "同步目录"],
  ["tu.limit", "{used} of {limit} branches in use", "已使用 {used} / {limit} 家分店"],
  ["tu.limit.included", "Your plan includes {n}; each additional branch is USD 30 / month.", "方案已包含 {n} 家；每增加一家分店 USD 30 / 月。"],
  ["tu.limit.add", "Add a branch in Plan & billing", "在「方案与账单」增加分店"],
  ["tu.limit.full", "All your branches are in use. Add one more in Plan & billing (USD 30 / branch / month).", "分店名额已用完。可在「方案与账单」增加分店（每家 USD 30 / 月）。"],
  ["tu.k.sales", "Sales", "营业额"],
  ["tu.k.orders", "{n} orders", "{n} 笔订单"],
  ["tu.k.stock", "Stock value", "库存价值"],
  ["tu.k.low", "{n} low", "{n} 项偏低"],
  ["tu.k.team", "{staff} staff · {cashiers} cashier logins", "{staff} 位员工 · {cashiers} 个收银账号"],
  ["tu.k.noCashier", "No cashier login", "没有收银账号"],
  ["tu.k.transfers", "{in} incoming · {out} outgoing", "{in} 笔调入 · {out} 笔调出"],
  ["tu.range", "Last 30 days", "最近 30 天"],
  ["tu.emp.title", "Employees across branches", "各分店员工"],
  ["tu.emp.name", "Name", "姓名"],
  ["tu.emp.role", "Role", "角色"],
  ["tu.emp.branches", "Branches", "分店"],
  ["tu.emp.sales", "Sales (by branch)", "业绩（按分店）"],
  ["tu.emp.all", "All branches", "所有分店"],
  ["tu.emp.none", "No sales in this period", "此期间没有业绩"],
  ["tu.stock.search", "Search items", "搜索品项"],
  ["tu.stock.item", "Item", "品项"],
  ["tu.stock.inbound", "+{n} on the way", "在途 +{n}"],
  ["tu.stock.empty", "No stock items yet.", "尚无库存品项。"],
  ["tu.tr.new", "New transfer", "新调拨"],
  ["tu.tr.from", "From branch", "调出分店"],
  ["tu.tr.to", "To branch", "调入分店"],
  ["tu.tr.item", "Item", "品项"],
  ["tu.tr.qty", "Quantity", "数量"],
  ["tu.tr.addLine", "Add item", "添加品项"],
  ["tu.tr.note", "Note", "备注"],
  ["tu.tr.receiveNow", "Received at the other branch too (skip confirmation)", "对方分店同时签收（跳过确认）"],
  ["tu.tr.receiveNowHint", "Only the owner can skip the receiving branch's confirmation.", "只有店主可以跳过调入分店的签收确认。"],
  ["tu.tr.send", "Send transfer", "发出调拨"],
  ["tu.tr.sent", "Transfer {no} sent", "调拨单 {no} 已发出"],
  ["tu.tr.empty", "No transfers yet.", "暂无调拨。"],
  ["tu.tr.filterOpen", "Open", "未完成"],
  ["tu.tr.filterAll", "All", "全部"],
  ["tu.tr.st.sent", "On the way", "在途"],
  ["tu.tr.st.partially_received", "Partly received", "部分签收"],
  ["tu.tr.st.received", "Received", "已签收"],
  ["tu.tr.st.closed", "Closed", "已结单"],
  ["tu.tr.st.cancelled", "Cancelled", "已取消"],
  ["tu.tr.lineQty", "{sent} sent · {got} received", "发出 {sent} · 签收 {got}"],
  ["tu.tr.lineLost", "{n} lost", "遗失 {n}"],
  ["tu.tr.lineReturned", "{n} returned", "退回 {n}"],
  ["tu.tr.inTransit", "In transit: {value}", "在途价值：{value}"],
  ["tu.tr.receive", "Receive", "签收"],
  ["tu.tr.receiveTitle", "Receive {no}", "签收 {no}"],
  ["tu.tr.receiveHint", "Enter what actually arrived. Anything missing stays on the way until it arrives or the transfer is closed.", "填写实际到货数量。缺少的部分保持在途，直到到货或结单。"],
  ["tu.tr.arrived", "Arrived", "到货"],
  ["tu.tr.ofOpen", "of {n} on the way", "（在途 {n}）"],
  ["tu.tr.confirm", "Confirm receipt", "确认签收"],
  ["tu.tr.received", "Receipt saved", "已签收"],
  ["tu.tr.close", "Close", "结单"],
  ["tu.tr.closeTitle", "Close {no}", "结单 {no}"],
  ["tu.tr.closeHint", "What has not arrived:", "尚未到货的部分："],
  ["tu.tr.return", "Return it to the sending branch", "退回调出分店"],
  ["tu.tr.lost", "Write it off as lost in transit", "作为运输遗失注销"],
  ["tu.tr.reason", "Reason (required)", "原因（必填）"],
  ["tu.tr.closed", "Transfer closed", "调拨已结单"],
  ["tu.tr.cancel", "Cancel transfer", "取消调拨"],
  ["tu.tr.cancelConfirm", "Cancel this transfer? Everything goes back to the sending branch.", "取消此调拨？所有货品退回调出分店。"],
  ["tu.tr.cancelled", "Transfer cancelled", "调拨已取消"],
  ["tu.tr.by", "by {name}", "由 {name}"],
  ["tu.sh.title", "What branches share", "分店之间共享什么"],
  ["tu.sh.sub", "Each switch is separate. Every change is saved as a new version with who changed it and when.", "每项开关独立设置。每次修改都会保存为新版本，记录修改人和时间。"],
  ["tu.sh.customers", "Customers", "顾客"],
  ["tu.sh.customers.shared", "Shared — every branch sees every customer", "共享 —— 每家分店都能看到所有顾客"],
  ["tu.sh.customers.per_branch", "Per branch — branch staff see the customers of their own branches", "按分店 —— 分店员工只看到本分店的顾客"],
  ["tu.sh.productCatalog", "Same product range at every branch", "所有分店产品目录相同"],
  ["tu.sh.productCatalog.d", "New and edited products are sold at every branch.", "新增或修改的产品在所有分店销售。"],
  ["tu.sh.productPrices", "Same product prices at every branch", "所有分店产品价格相同"],
  ["tu.sh.productPrices.d", "No branch prices for products — one price everywhere.", "产品不设分店价，所有分店统一价格。"],
  ["tu.sh.serviceCatalog", "Same service menu at every branch", "所有分店服务项目相同"],
  ["tu.sh.serviceCatalog.d", "New and edited services are offered at every branch.", "新增或修改的服务在所有分店提供。"],
  ["tu.sh.servicePrices", "Same service prices at every branch", "所有分店服务价格相同"],
  ["tu.sh.servicePrices.d", "No branch prices for services — one price everywhere.", "服务不设分店价，所有分店统一价格。"],
  ["tu.sh.packages", "Packages can be used at other branches", "配套可在其他分店使用"],
  ["tu.sh.packages.d", "Off: a package is used only at the branch that sold it.", "关闭：配套只能在售出的分店使用。"],
  ["tu.sh.memberships", "Membership prices at every branch", "会员价适用于所有分店"],
  ["tu.sh.memberships.d", "Off: member prices apply only at the customer's home branch.", "关闭：会员价只适用于顾客所属分店。"],
  ["tu.sh.storedValue", "Stored value can be spent at every branch", "储值可在所有分店消费"],
  ["tu.sh.storedValue.d", "Off: credit is spent only at a branch where the customer topped up.", "关闭：储值只能在顾客充值的分店消费。"],
  ["tu.sh.staff", "Staff work at every branch", "员工可在所有分店工作"],
  ["tu.sh.staff.d", "New staff get every branch; switching on links all staff (managers and cashier logins keep their branches).", "新员工默认所有分店；开启时为所有员工关联所有分店（经理与收银账号保留原分店）。"],
  ["tu.sh.transferReceipt", "Transfers need the receiving branch to confirm", "调拨需调入分店签收确认"],
  ["tu.sh.transferReceipt.d", "Stock arrives only when the other branch confirms what came (partial deliveries allowed).", "对方分店确认到货后库存才入账（允许部分到货）。"],
  ["tu.sh.impact.products", "{missing} product listings will be added at other branches", "将在其他分店新增 {missing} 个产品上架"],
  ["tu.sh.impact.services", "{missing} service listings will be added at other branches", "将在其他分店新增 {missing} 个服务上架"],
  ["tu.sh.impact.prices", "{n} branch prices will be replaced by the main price", "{n} 个分店价将改为统一价格"],
  ["tu.sh.impact.staff", "{n} staff-branch links will be added", "将新增 {n} 个员工与分店的关联"],
  ["tu.sh.saved", "Sharing settings saved", "共享设置已保存"],
  ["tu.sh.history", "Change history", "修改记录"],
  ["tu.sh.default", "Default", "默认"],
  ["tu.sy.title", "Copy catalogue between branches", "在分店之间复制目录"],
  ["tu.sy.sub", "Make what one branch sells available at other branches. Nothing is removed.", "把一家分店销售的项目上架到其他分店。不会删除任何项目。"],
  ["tu.sy.from", "Copy from", "复制自"],
  ["tu.sy.to", "To", "复制到"],
  ["tu.sy.products", "Products", "产品"],
  ["tu.sy.services", "Services", "服务"],
  ["tu.sy.prices", "Also copy branch prices", "同时复制分店价"],
  ["tu.sy.run", "Sync now", "立即同步"],
  ["tu.sy.done", "{added} listings added, {priced} prices updated", "新增 {added} 个上架，更新 {priced} 个价格"],
  ["tu.co.bannerTransition", "Checkout now uses cashier logins: owner and staff accounts will not ring up sales. Create a cashier login per branch — until you switch, you can keep selling as before.", "收银改为使用收银账号：店主与员工账号不再收款。请为每家分店创建收银账号 —— 切换前你仍可照常收款。"],
  ["tu.co.bannerNoCashier", "This branch has no cashier login yet, so you can still ring up sales here. Create one to hand checkout to the front desk.", "此分店尚无收银账号，因此你仍可在此收款。创建收银账号，把收银交给前台。"],
  ["tu.co.create", "Create cashier login", "创建收银账号"],
  ["tu.co.switch", "Switch to cashier-only checkout", "改为仅收银账号收款"],
  ["tu.co.switchConfirm", "From now on only cashier logins ring up sales. Branches without a cashier login keep owner checkout until they have one. This can't be undone.", "从现在起只有收银账号可以收款。尚无收银账号的分店，店主仍可收款直到创建账号。此操作无法撤销。"],
  ["tu.co.switched", "Cashier-only checkout is on", "已改为仅收银账号收款"],
  ["tu.co.title", "New cashier login", "新收银账号"],
  ["tu.co.hint", "A cashier login is a separate account used at the counter. It can only ring up sales at the branches you choose.", "收银账号是前台专用的独立账号，只能在你选择的分店收款。"],
  ["tu.co.name", "Name shown on receipts", "收据显示名称"],
  ["tu.co.email", "Login e-mail", "登录邮箱"],
  ["tu.co.emailHint", "Must not be used by another Senvia POS login. Tip: name+cashier@yourdomain.com reaches your own inbox.", "不可与其他 Senvia POS 账号重复。提示：name+cashier@yourdomain.com 会发到你自己的邮箱。"],
  ["tu.co.branches", "Branches", "分店"],
  ["tu.co.done", "Cashier login created", "收银账号已创建"],
  ["tu.co.password", "Temporary password (shown once): {pw}", "临时密码（仅显示一次）：{pw}"],
  ["tu.co.passwordHint", "Sign in at the counter with this e-mail and password; a new password is set at first sign-in.", "在前台用此邮箱和密码登录；首次登录时需设置新密码。"],
  ["tu.co.posBlocked", "Sales are rung up with a cashier login", "收款需使用收银账号"],
  ["tu.co.posBlockedSub", "Owner and staff accounts don't take payments. Sign in at the counter with this branch's cashier login. You still see every sale in Sales and Reports.", "店主与员工账号不收款。请在前台用本分店的收银账号登录。你仍可在「销售」和「报表」中查看所有交易。"],
  ["tu.co.cashiers", "Cashier logins", "收银账号"],
  ["tu.co.cashiersSub", "Only cashier logins ring up sales. One per branch (or more).", "只有收银账号可以收款。每家分店一个（或多个）。"],
  ["tu.co.none", "No cashier login yet", "尚无收银账号"],
  ["tu.co.mode.transition", "Transition: owner checkout still on", "过渡期：店主仍可收款"],
  ["tu.co.mode.cashier_only", "Cashier-only checkout", "仅收银账号收款"],
  ["tu.team.branches", "Works at", "工作分店"],
  ["tu.portal.title", "Staff portal", "员工门户"],
  ["tu.portal.sub", "What staff see about themselves on the web (nothing about other staff or the shop).", "员工在网页上可查看自己的资料（看不到其他员工或店铺数据）。"],
  ["tu.portal.enabled", "Staff portal on", "开启员工门户"],
  ["tu.portal.showCommission", "Show commission amounts", "显示佣金金额"],
  ["tu.portal.showContacts", "Show their customers' phone and e-mail", "显示其顾客的电话与邮箱"],
  ["tu.portal.customers", "Their customers", "其顾客范围"],
  ["tu.portal.customers.assigned", "Assigned to them", "指定给他们的顾客"],
  ["tu.portal.customers.served", "Assigned or served by them", "指定或服务过的顾客"],
  ["tu.portal.saved", "Staff portal settings saved", "员工门户设置已保存"],
  ["tu.me.perf", "My performance", "我的业绩"],
  ["tu.me.customers", "My customers", "我的顾客"],
  ["tu.me.attendance", "My attendance", "我的考勤"],
  ["tu.me.statements", "My statements", "我的结算"],
  ["tu.me.sales", "Sales", "业绩"],
  ["tu.me.commission", "Commission", "佣金"],
  ["tu.me.appointments", "Appointments", "预约"],
  ["tu.me.clients", "Clients", "顾客"],
  ["tu.me.byType", "By type", "按类型"],
  ["tu.me.byDay", "By day", "按日"],
  ["tu.me.noData", "Nothing in this period yet.", "此期间暂无数据。"],
  ["tu.me.visits", "{n} visits with me", "我服务 {n} 次"],
  ["tu.me.last", "Last: {date}", "最近：{date}"],
  ["tu.me.assigned", "Assigned to me", "指定给我"],
  ["tu.me.noCustomers", "No customers yet.", "暂无顾客。"],
  ["tu.me.month", "Month", "月份"],
  ["tu.me.from", "From", "从"],
  ["tu.me.to", "To", "至"],
  ["tu.me.days", "Days worked", "出勤天数"],
  ["tu.me.hours", "Hours worked", "工作时数"],
  ["tu.me.in", "In", "上班"],
  ["tu.me.out", "Out", "下班"],
  ["tu.me.break", "Break", "休息"],
  ["tu.me.worked", "Worked", "工时"],
  ["tu.me.open", "Still clocked in", "仍在上班"],
  ["tu.me.corrected", "corrected", "已更正"],
  ["tu.me.noShifts", "No shifts this month.", "本月没有打卡记录。"],
  ["tu.me.payslipsLink", "Payslips are under My payroll.", "工资单请见「我的薪资」。"],
  ["tu.me.statementHint", "Monthly summary of your sales and commission. Your salon pays wages outside Senvia POS.", "每月业绩与佣金汇总。工资由店铺在 Senvia POS 之外发放。"],
  ["tu.me.off", "The staff portal is switched off for this salon.", "本店已关闭员工门户。"],
  ["tu.plan.branches", "{used} of {limit} branches in use — your first branch is included.", "已使用 {used} / {limit} 家分店 —— 第一家分店已包含。"],
] as const;

export type TuKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<TuKey, string>;

export const taskU = { en: col(1), zh: col(2), ms: col(1) };
